export const LIST_BALANCES= 'LIST_BALANCES';
export const LIST_BALANCES_LOADING = 'LIST_BALANCES_LOADING';
export const LIST_TRANSACTIONS_BALANCES = 'LIST_TRANSACTIONS_BALANCES';
export const LIST_TRANSACTIONS_BALANCES_LOADING = 'LIST_TRANSACTIONS_BALANCES_LOADING';